// extracted by mini-css-extract-plugin
export var billingAddress = "_r6-f";
export var contactInfo = "_r6-c";
export var customerInfoContainer = "_r6-b";
export var customerInfoRow = "_r6-9";
export var customerInfoSection = "_r6-a";
export var fullWidthDividerMobile = "_r6-g";
export var imageContainer = "_r6-1";
export var paymentMethod = "_r6-d";
export var priceText = "_r6-6";
export var priceTextMobile = "_r6-7";
export var product = "_r6-0";
export var productImage = "_r6-2";
export var productInfo = "_r6-4";
export var productTitle = "_r6-8";
export var quantityBadge = "_r6-3";
export var quantityText = "_r6-5";
export var shippingAddress = "_r6-e";